import { connect } from 'react-redux'
import TransactionsView from '../components/TransactionsView'
import {loadTransactions, changeFilterDates, cancelTransaction} from '../modules/transactions'
import {printReceipt} from "../../ShoppingCart/modules/shoppingCart";
import moment from 'moment'

const mapDispatchToProps = {
  cancelTransaction,
  loadTransactions,
  changeFilterDates,
  printReceipt
};

const mapStateToProps = (state) => {

  return {
    filter_start_date: state.transactions.filter_start_date ? moment(state.transactions.filter_start_date) : null,
    filter_end_date: state.transactions.filter_end_date ? moment(state.transactions.filter_end_date) : null,
    transactions: state.transactions.list
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(TransactionsView)


// WEBPACK FOOTER //
// ./src/components/Transactions/containers/TransactionsViewContainer.js